/* =========================================================
   ats — Gift Cart Slider With Snackbar + Confetti
   ========================================================= */

(function () {
  class atsGiftCartSlider {
    constructor() {
      this._skipNextSync = false;

      document.addEventListener('cart:updated', (e) => {
        const cart = e?.detail?.cart;
        if (cart) this.onCartUpdated(cart);
      });

      /* ===============================
         REMOVE ALL GIFTS BUTTON
      =============================== */
      document.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-ats-gift-remove-all]');
        if (!btn) return;

        const cart = await fetch('/cart.js').then((r) => r.json());

        const updates = {};

        cart.items.forEach((item) => {
          if (item.properties?._ats_gift) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) return;

        // prevent auto re-add
        this._skipNextSync = true;

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });

        const newCart = await fetch('/cart.js').then((r) => r.json());

        // update UI immediately
        const root = this.getRoot();

        if (root) {
          const fill = root.querySelector('[data-ats-cart-gift-fill]');
          const msgMain = root.querySelector('[data-ats-cart-gift-msg-main]');
          const msgSub = root.querySelector('[data-ats-cart-gift-msg-sub]');

          if (fill) fill.style.width = '0%';
          if (msgMain) msgMain.textContent = 'Free gifts removed';
          if (msgSub) msgSub.textContent = '';
        }

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: { cart: newCart },
          }),
        );

        document.dispatchEvent(
          new CustomEvent('cart:build', {
            detail: { cart: newCart },
          }),
        );
      });
    }

    /* ---------- ROOT ---------- */
    getRoot() {
      return (
        document.querySelector('#confetti-cart-drawer [data-ats-cart-gift]') ||
        document.querySelector('.ats-freebieProgressbarWrapper [data-ats-cart-gift]') ||
        document.querySelector('[data-ats-cart-gift]')
      );
    }
    /* ---------- CONFIG ---------- */
    getConfig(root) {
      const script = root?.querySelector('[data-ats-cart-gift-json]');
      let raw = [];

      try {
        raw = JSON.parse(script?.textContent || '[]');
      } catch (_) {}

      const tiers = (raw || [])
        .filter((t) => t && t.amount > 0 && t.variant_id)
        .map((t) => ({
          key: String(t.key),
          label: String(t.label || ''),
          variantId: Number(t.variant_id),
          thresholdAmountCents: Math.round(Number(t.amount) * 100),
          progressAmountCents: Math.round(Number(t.progress_amount || t.amount) * 100),
        }))
        .sort((a, b) => a.progressAmountCents - b.progressAmountCents);

      return {
        tiers,
        moneyFormat: root.dataset.moneyFormat || 'Rs.{{amount}}',
        msgLocked: root.dataset.msgLocked || '',
        msgUnlocked: root.dataset.msgUnlocked || '',
        msgComplete: root.dataset.msgComplete || '',
      };
    }

    /* ---------- HELPERS ---------- */
    isGiftItem(item) {
      return item?.properties?._ats_gift;
    }

    paidSubtotalCents(cart) {
      return (cart.items || []).reduce((sum, i) => {
        if (this.isGiftItem(i)) return sum;
        return sum + (i.final_line_price || i.line_price || 0);
      }, 0);
    }

    formatMoney(fmt, cents) {
      const val = (cents / 100).toFixed(2);
      return fmt.replace('{{amount}}', val);
    }

    refreshCartEvents(cart) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart },
        }),
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { cart },
        }),
      );

      document.dispatchEvent(
        new CustomEvent('cart:build', {
          detail: { cart },
        }),
      );
    }

    /* ---------- SNACKBAR ---------- */
    showGiftSnackbar(message) {
      const root = this.getRoot();
      const snackbar =
        root?.querySelector('[data-ats-gift-snackbar]') || document.querySelector('[data-ats-gift-snackbar]');

      if (!snackbar) return;

      snackbar.textContent = message || '🎉 Free gift added to your cart!';
      snackbar.classList.add('is-visible');

      clearTimeout(this._snackbarTimer);

      this._snackbarTimer = setTimeout(() => {
        snackbar.classList.remove('is-visible');
      }, 3000);
    }

    /* ---------- CONFETTI ---------- */
    createConfetti() {
      const colors = [
        '#ff4d4d',
        '#ffd93d',
        '#6bff95',
        '#4d96ff',
        '#c77dff',
        '#ff8fab',
        '#ffffff',
        '#ff9f1c',
        '#2ec4b6',
      ];

      for (let i = 0; i < 120; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'ats-confetti';

        const width = Math.random() * 8 + 4;
        const height = Math.random() * 14 + 6;
        const drift = Math.random() * 240 - 120;

        const rotateDirection = Math.random() > 0.5 ? 1 : -1;
        const rotateAmount = (Math.random() * 720 + 180) * rotateDirection;

        const duration = Math.random() * 1.8 + 1.4;
        const delay = Math.random() * 0.35;

        confetti.style.left = Math.random() * 100 + 'vw';
        confetti.style.width = width + 'px';
        confetti.style.height = height + 'px';
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];

        confetti.style.animationDuration = duration + 's';
        confetti.style.animationDelay = delay + 's';

        confetti.style.setProperty('--ats-drift', drift + 'px');
        confetti.style.setProperty('--ats-rotate', rotateAmount + 'deg');

        const shape = Math.random();

        if (shape > 0.7) {
          confetti.style.borderRadius = '50%';
        } else if (shape > 0.45) {
          confetti.style.borderRadius = '3px';
        } else {
          confetti.style.borderRadius = '0';
        }

        document.body.appendChild(confetti);

        setTimeout(
          () => {
            confetti.remove();
          },
          (duration + delay) * 1000,
        );
      }
    }

    showGiftCelebration(productName) {
      if (document.body.classList.contains('template-product')) return;
      const message = productName ? `🎉 ${productName} added as a free gift!` : '🎉 Free gift added to your cart!';

      this.showGiftSnackbar(message);
      this.createConfetti();
    }

    /* ---------- UI UPDATE ---------- */
    updateUI(root, cfg, cart) {
      const paid = this.paidSubtotalCents(cart);
      const max = cfg.tiers[cfg.tiers.length - 1]?.progressAmountCents || 1;

      const fill = root.querySelector('[data-ats-cart-gift-fill]');
      const msgMain = root.querySelector('[data-ats-cart-gift-msg-main]');
      const msgSub = root.querySelector('[data-ats-cart-gift-msg-sub]');
      const markers = root.querySelector('[data-ats-cart-gift-markers]');
      const labels = root.querySelector('[data-ats-cart-gift-labels]');

      const pct = Math.min(100, (paid / max) * 100);

      if (fill) fill.style.width = pct + '%';

      if (markers) markers.innerHTML = '';
      if (labels) labels.innerHTML = '';

      cfg.tiers.forEach((t) => {
        const left = (t.progressAmountCents / max) * 100;
        const unlocked = paid >= t.progressAmountCents;

        const m = document.createElement('span');
        m.className = 'ats-cartGift__marker';
        m.style.left = left + '%';
        m.style.transform = 'translate(-50%, -50%)';
        m.style.opacity = unlocked ? '1' : '.85';

        m.innerHTML = `
          <svg style="width: var(--ats-progressbar-icon-size); height: var(--ats-progressbar-icon-size);" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M32 10.015c0-1.104-0.895-2-2-2h-3.414c0.884-0.872 1.449-2.014 1.449-3.421 0-1.732-0.995-3.615-3.788-3.615-3.675 0-6.745 3.913-8.188 6.106-1.444-2.193-4.607-6.106-8.282-6.106-2.793 0-3.788 1.882-3.788 3.614 0 1.407 0.581 2.55 1.482 3.421h-3.472c-1.105 0-2 0.896-2 2v5.986h2.018v13.017c0 1.105 0.895 2 2 2h23.99c1.105 0 2-0.895 2-2v-13.018h1.992v-5.986zM24.247 2.981c1.236 0 1.788 0.52 1.788 1.615 0 2.221-2.479 3.42-4.811 3.42h-3.386c1.421-2.111 3.922-5.035 6.409-5.035zM7.778 2.981c2.487 0 5.083 2.924 6.504 5.034h-3.386c-2.332 0-4.905-1.229-4.905-3.451 0-1.095 0.551-1.583 1.788-1.583zM30 14.002h-13v-3.986h13v3.986zM2 10.015h13v3.986h-13zM4.018 16.002h10.982v13.018h-10.982zM28.008 29.020h-11.008v-13.017h11.008v13.017z"
              fill="var(--ats-progressbar-icon-color)"
              stroke="var(--ats-progressbar-icon-color)">
            </path>
          </svg>
        `;

        markers.appendChild(m);

        const l = document.createElement('span');
        l.className = 'ats-cartGift__label';
        l.style.left = left + '%';
        l.textContent = t.label;
        l.style.whiteSpace = 'pre-line';
        labels.appendChild(l);
      });

      const next = cfg.tiers.find((t) => paid < t.progressAmountCents);

      if (!next) {
        if (msgMain) {
          msgMain.textContent = cfg.msgComplete || 'All gifts unlocked!';
          msgMain.style.display = '';
        }

        if (msgSub) {
          msgSub.textContent = '';
          msgSub.style.display = 'none';
        }

        return;
      }

      const remaining = next.progressAmountCents - paid;
      const amountStr = this.formatMoney(cfg.moneyFormat, remaining);

      const hasGiftInCart = (cart.items || []).some((i) => this.isGiftItem(i));

      if (msgMain) {
        if (hasGiftInCart) {
          msgMain.textContent = cfg.msgUnlocked || 'Congratulations! You’ve unlocked a free gift 🎉';
          msgMain.style.display = '';
        } else {
          msgMain.textContent = '';
          msgMain.style.display = 'none';
        }
      }

      if (msgSub) {
        msgSub.textContent = cfg.msgLocked.replace('{{amount}}', amountStr) || `Add ${amountStr} more to unlock gift`;

        msgSub.style.display = '';
      }
    }

    /* ---------- SYNC GIFTS ---------- */
    async syncGifts(cfg, cart) {
      if (this._skipNextSync) {
        this._skipNextSync = false;
        return false;
      }

      const paid = this.paidSubtotalCents(cart);

      const achieved = cfg.tiers.filter((t) => paid >= t.thresholdAmountCents);
      const desiredVariantIds = new Set(achieved.map((t) => t.variantId));

      const items = cart.items || [];
      const giftItems = items.filter((i) => this.isGiftItem(i));

      let changed = false;
      let addedGiftProductName = '';

      /* =========================
         REMOVE INVALID GIFTS
      ========================= */
      for (const item of giftItems) {
        if (!desiredVariantIds.has(item.variant_id)) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
          });

          changed = true;
        }
      }

      /* =========================
        ADD MISSING GIFTS
      ========================= */
      const existing = new Set(giftItems.map((i) => i.variant_id));

      for (const t of achieved) {
        if (!existing.has(t.variantId)) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: t.variantId,
              quantity: 1,
              properties: {
                _ats_gift: '1',
              },
            }),
          });

          changed = true;

          // Get latest cart after adding gift
          const latestCart = await fetch('/cart.js').then((r) => r.json());

          const addedGiftItem = latestCart.items.find((item) => {
            return item.variant_id === t.variantId && item.properties?._ats_gift;
          });

          addedGiftProductName = addedGiftItem?.product_title || addedGiftItem?.title || 'Free gift';
        }
      }

      if (addedGiftProductName) {
        this.showGiftCelebration(addedGiftProductName);
      }

      return changed;
    }

    /* ---------- MAIN ---------- */
    async onCartUpdated(cart) {
      const root = this.getRoot();
      if (!root) return;

      const cfg = this.getConfig(root);
      if (!cfg.tiers.length) return;

      this.updateUI(root, cfg, cart);

      const changed = await this.syncGifts(cfg, cart);

      if (changed) {
        const fresh = await fetch('/cart.js').then((r) => r.json());

        this.updateUI(root, cfg, fresh);
        this.refreshCartEvents(fresh);
      }
    }
  }

  /* ---------- INIT ---------- */
  document.addEventListener('DOMContentLoaded', async () => {
    window.ats = window.ats || {};

    if (!window.ats.giftSlider) {
      window.ats.giftSlider = new atsGiftCartSlider();
    }

    const cart = await fetch('/cart.js').then((r) => r.json());
    window.ats.giftSlider.onCartUpdated(cart);
  });
})();
